<template>
  <div class="content-firms container-fluid">
    <div class="content-firms__chart row">

      <div v-if="content.chart" class="bubble-header col-xs-12 col-12 col-sm-10 col-sm-offset-1 offset-sm-1 col-md-8 col-md-offset-2 offset-md-2">
        <div class="bubble-header__title row">
          <div class="col-sm-12">
            <h3>
              {{ content.chart.title }} <br />
              <span class="font-weight-light">{{ content.chart.year }}</span>
            </h3>
          </div>
        </div>
        <div class="bubble-header__instructions row">
          <div class="col-sm-12">
            <p>
              {{ content.chart.instruction }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-12 col-sm-10 col-sm-offset-1 offset-sm-1 col-md-8 col-md-offset-2 offset-md-2">
        <Bubble />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Firms',
  components: {
    Bubble: () => import('@/components/content/charts/Bubble.vue'),
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  }
};
</script>

<style lang="scss" scoped>
.content-firms {
  &__texts {
    padding: 60px 0;

    .firms-intro__paragraphs {
      p:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__pullquote {
    .pull-quote {
      display: flex;

      &__icon {
        margin-right: 15px;
        font-size: 24px;
      }

      &__body {
        padding: 0;
        margin: 0;
        font-size: inherit;
        border-left: unset;

        footer {
          font-size: inherit;
          line-height: inherit;
          color: inherit;
          p {
            margin-bottom: 0;
            color: #121212;
          }

          .footer-name {
            font-family: 'Noto Sans Bold', sans-serif;
          }

          .footer-designation {
            font-family: 'Noto Sans Regular', sans-serif;
          }
        }
        footer:before {
          content: none;
        }
      }
    }
  }

  &__chart {
    padding-top: 60px;
  }

  @media #{map-get($media-breakpoints, 'mobile')} {
    &__texts {
      padding: 30px 0;
    }

    &__chart {
      padding-top: 30px;
    }
  }
}

.bubble-header {
  padding-bottom: 20px;

  &__instructions {
    padding-top: 5px;
  }
}
</style>
